import React from "react";
interface propData {
  selectedFarmerInfo: any;
}
function FarmerInfoForModal({ selectedFarmerInfo }: propData) {
  return (
    <div>
      <div className="flex flex-col bg-green-200 dark:text-gray-100 dark:bg-gray-600 p-1 justify-start gap-2  space-x-4">
        <span className="font-medium">
          نام روستا : {selectedFarmerInfo?.village_name}
        </span>
        <span className="font-medium">
          زمین ,(هکتار): {selectedFarmerInfo?.amount_of_land}
        </span>
        <span className="font-medium">
          تاریخ برداشت: {selectedFarmerInfo?.date_set}
        </span>
      </div>
    </div>
  );
}

export default FarmerInfoForModal;
